import emptyInfo from './empty-info'
export default emptyInfo
